import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import { formatarDataSimples } from '@spark/utils/formatters';

export const getVeiculoTabelaVinculoColumns = (onDelete, loadingDeleteId) => [
  {
    id: 'idTabelaPremiacao',
    accessorKey: 'idTabelaPremiacao',
    header: 'Id Tabela',
    size: 100,
    cell: ({ row }) => row.original.idTabelaPremiacao ?? '-'
  },
  {
    id: 'nomeTabelaPremiacao',
    accessorKey: 'nomeTabelaPremiacao',
    header: 'Nome Tabela',
    size: 220,
    cell: ({ row }) => row.original.nomeTabelaPremiacao || '-'
  },
  {
    id: 'data',
    accessorKey: 'data',
    header: 'Data Vinculo',
    size: 140,
    cell: ({ row }) => (row.original.data ? formatarDataSimples(row.original.data) : '-')
  },
  {
    id: 'usuarioCriacao',
    accessorKey: 'usuarioCriacao',
    header: 'Usuario',
    size: 160,
    cell: ({ row }) => row.original.usuarioCriacao || '-'
  },
  {
    id: 'acoes',
    header: 'Acoes',
    size: 80,
    enableSorting: false,
    cell: ({ row }) => (
      <Tooltip dir="top" text="Excluir vinculo">
        <span className="d-inline-block">
          <ButtonWithLoading
            variant="outline-danger"
            size="sm"
            loading={loadingDeleteId === row.original.id}
            disabled={loadingDeleteId === row.original.id}
            onClick={(event) => {
              event.stopPropagation();
              onDelete(row.original.id);
            }}
          >
            <Icon name="trash" size={16} />
          </ButtonWithLoading>
        </span>
      </Tooltip>
    )
  }
];
